import { defineStore } from 'pinia'

interface CacheState {
  cache: Record<string, any>
}

export const useCacheStore = defineStore('cache', {
  state: (): CacheState => ({
    cache: {}
  }),

  actions: {
    has(key: string): boolean {
      return Object.prototype.hasOwnProperty.call(this.cache, key)
    },

    set(key: string, value: any): void {
      this.cache[key] = value
    },

    get(key: string): any {
      return this.has(key) ? this.cache[key] : false
    }
  }
})
